"use strict";

const get = require("lodash/get");
const jq = require("json-query");
const containedMapping = require("./containedMapping");

const getMappingbyText = (text) =>
  (containedMapping || []).find((map) => map.text === text);

const toYesNo = (value) => {
  if (value === true) {
    return "yes";
  } else if (value === false) {
    return "no";
  }

  return "";
};

const toString = (value) => {
  if (value) {
    return value.toString();
  }

  return "";
};

const reverseTransformValue = (value, map) => {
  if (map.preventReverse) {
    return value;
  }

  switch (map.type) {
    case "boolean":
      return toYesNo(value);
    case "integer":
      return toString(value);
    default:
      return value;
  }
};

const unmapContained = (contained) => {
  const unmapped = {};

  contained.forEach((item) => {
    const map = getMappingbyText(item.text);
    const answer = item.answer[0];

    if (map) {
      unmapped[map.key] = reverseTransformValue(
        answer[Object.keys(answer)[0]],
        map
      );
    }
  });

  return unmapped;
};

const unmapTelecom = (person, telecom = []) => {
  person.emails = [];
  person.phones = [];

  telecom.forEach((item) => {
    if (item.system === "phone") {
      person.phones.push({
        number: item.value,
        phoneType: item.use,
        preferred: item.rank === 1
      });
    } else {
      person.emails.push({
        address: item.value,
        preferred: item.rank === 1
      });
    }
  });

  return person;
};

const mapToForm = (person) => {
  const unmappedPerson = {
    id: person.id,
    lastName: get(person, "name[0].family[0]", ""),
    firstName: get(person, "name[0].given[0]", ""),
    middleName: get(person, "name[0].given[1]", ""),
    suffix: get(person, "name[0].suffix[0]", ""),
    relationship: get(person, "relationship.coding[0].code", ""),
    dob: get(person, "birthDate"),
    address1: get(person, "address[0].line[0]", ""),
    address2: get(person, "address[0].line[1]", ""),
    city: get(person, "address[0].city", ""),
    state: get(person, "address[0].state", ""),
    zip: get(person, "address[0].postalCode", ""),
    narus: unmapContained(get(person, "contained[0].item", [])),
    notes: jq(
      "extension[url=http://narushealth.com/fhir/support-network-member-notes].valueString",
      { data: person }
    ).value,
    link: jq(
      "extension[url=http://narushealth.com/fhir/support-network-member-link].valueString",
      { data: person }
    ).value
  };

  return unmapTelecom(unmappedPerson, person.telecom);
};

module.exports = {
  mapToForm
};
